'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { Search, SlidersHorizontal, Star, Users, Clock, BookOpen, Heart, Lock } from 'lucide-react';

const allCourses = [
{
  id: 'cat-001',
  title: 'Machine Learning Fundamentals',
  instructor: 'Dr. Marcus Chen',
  topic: 'AI & Machine Learning',
  topicClass: 'badge-topic-ai',
  difficulty: 'Intermediate',
  difficultyClass: 'badge-difficulty-intermediate',
  rating: 4.8,
  reviewCount: 1243,
  students: 8421,
  lessons: 18,
  duration: '12h 30m',
  price: 'Free',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1b9b78950-1774149821493.png",
  thumbnailAlt: 'Glowing neural network nodes interconnected on dark blue background',
  enrolled: true,
  bestseller: true
},
{
  id: 'cat-002',
  title: 'Python for Data Science: Zero to Hero',
  instructor: 'Aisha Nwosu',
  topic: 'Data Science',
  topicClass: 'badge-topic-data',
  difficulty: 'Beginner',
  difficultyClass: 'badge-difficulty-beginner',
  rating: 4.9,
  reviewCount: 2187,
  students: 12340,
  lessons: 24,
  duration: '16h 45m',
  price: 'Free',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1f265c71a-1772065606004.png",
  thumbnailAlt: 'Green matrix code on dark terminal screen',
  enrolled: true,
  bestseller: false
},
{
  id: 'cat-003',
  title: 'Introduction to Health Informatics',
  instructor: 'Dr. Priya Sharma',
  topic: 'Health Informatics',
  topicClass: 'badge-topic-health',
  difficulty: 'Beginner',
  difficultyClass: 'badge-difficulty-beginner',
  rating: 4.7,
  reviewCount: 876,
  students: 5210,
  lessons: 16,
  duration: '10h 20m',
  price: 'Free',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_195a6e902-1764648555298.png",
  thumbnailAlt: 'Doctor using digital tablet to review patient health records in modern hospital',
  enrolled: true,
  bestseller: false
},
{
  id: 'cat-004',
  title: 'Scratch Coding for Kids: Storytelling',
  instructor: 'Jamie Okonkwo',
  topic: 'Coding for Kids',
  topicClass: 'badge-topic-kids',
  difficulty: 'Beginner',
  difficultyClass: 'badge-difficulty-beginner',
  rating: 4.9,
  reviewCount: 1560,
  students: 9870,
  lessons: 12,
  duration: '6h 15m',
  price: 'Free',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_14b6860a3-1772094479185.png",
  thumbnailAlt: 'Smiling children learning to code on colorful laptops in bright classroom',
  enrolled: false,
  bestseller: true
},
{
  id: 'cat-005',
  title: 'Deep Learning with TensorFlow 2.x',
  instructor: 'Dr. Marcus Chen',
  topic: 'AI & Machine Learning',
  topicClass: 'badge-topic-ai',
  difficulty: 'Advanced',
  difficultyClass: 'badge-difficulty-advanced',
  rating: 4.8,
  reviewCount: 934,
  students: 4120,
  lessons: 22,
  duration: '18h 10m',
  price: 'Free',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1535839c6-1772274626046.png",
  thumbnailAlt: 'Abstract 3D blue neural network layers with glowing connection lines',
  enrolled: false,
  bestseller: false
},
{
  id: 'cat-006',
  title: 'Clinical Data Analysis with R',
  instructor: 'Dr. Priya Sharma',
  topic: 'Health Informatics',
  topicClass: 'badge-topic-health',
  difficulty: 'Advanced',
  difficultyClass: 'badge-difficulty-advanced',
  rating: 4.6,
  reviewCount: 412,
  students: 1870,
  lessons: 20,
  duration: '15h 45m',
  price: 'Free',
  thumbnail: "https://images.unsplash.com/photo-1723269489159-2258b7386e67",
  thumbnailAlt: 'Medical data charts and statistical graphs displayed on computer monitor',
  enrolled: false,
  bestseller: false
},
{
  id: 'cat-007',
  title: 'Natural Language Processing Essentials',
  instructor: 'Fatima Al-Rashid',
  topic: 'AI & Machine Learning',
  topicClass: 'badge-topic-ai',
  difficulty: 'Intermediate',
  difficultyClass: 'badge-difficulty-intermediate',
  rating: 4.7,
  reviewCount: 723,
  students: 3240,
  lessons: 16,
  duration: '11h 30m',
  price: 'Free',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1ecd441bb-1764661382270.png",
  thumbnailAlt: 'Abstract text processing visualization with flowing words and language patterns',
  enrolled: false,
  bestseller: false
},
{
  id: 'cat-008',
  title: 'Statistics for Data Science',
  instructor: 'Prof. Kofi Mensah',
  topic: 'Data Science',
  topicClass: 'badge-topic-data',
  difficulty: 'Intermediate',
  difficultyClass: 'badge-difficulty-intermediate',
  rating: 4.5,
  reviewCount: 1089,
  students: 6780,
  lessons: 20,
  duration: '14h 00m',
  price: 'Free',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1d3e8d771-1772632148690.png",
  thumbnailAlt: 'Statistical charts and graphs on white paper with pencil and calculator',
  enrolled: false,
  bestseller: false
},
{
  id: 'cat-009',
  title: 'Minecraft Modding for Young Coders',
  instructor: 'Jamie Okonkwo',
  topic: 'Coding for Kids',
  topicClass: 'badge-topic-kids',
  difficulty: 'Intermediate',
  difficultyClass: 'badge-difficulty-intermediate',
  rating: 4.8,
  reviewCount: 892,
  students: 5430,
  lessons: 14,
  duration: '8h 30m',
  price: 'Free',
  thumbnail: "https://images.unsplash.com/photo-1502267388920-aa14e67c55c5",
  thumbnailAlt: 'Teenager gaming on computer with colorful game world visible on screen',
  enrolled: false,
  bestseller: true
},
{
  id: 'cat-010',
  title: 'Interoperability & HL7 FHIR Standards',
  instructor: 'Dr. Samuel Osei',
  topic: 'Health Informatics',
  topicClass: 'badge-topic-health',
  difficulty: 'Advanced',
  difficultyClass: 'badge-difficulty-advanced',
  rating: 4.5,
  reviewCount: 287,
  students: 1120,
  lessons: 18,
  duration: '13h 20m',
  price: 'Free',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1185c2c78-1786476209123.png",
  thumbnailAlt: 'Digital medical data integration diagram showing connected hospital systems',
  enrolled: false,
  bestseller: false
},
{
  id: 'cat-011',
  title: 'Data Visualisation with Tableau',
  instructor: 'Aisha Nwosu',
  topic: 'Data Science',
  topicClass: 'badge-topic-data',
  difficulty: 'Beginner',
  difficultyClass: 'badge-difficulty-beginner',
  rating: 4.6,
  reviewCount: 1345,
  students: 7890,
  lessons: 15,
  duration: '9h 15m',
  price: 'Free',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_166783c0b-1772629263035.png",
  thumbnailAlt: 'Colourful data visualisation dashboard with bar charts and pie charts on screen',
  enrolled: false,
  bestseller: false
},
{
  id: 'cat-012',
  title: 'Python Games for Kids with PyGame',
  instructor: 'Leila Nakamura',
  topic: 'Coding for Kids',
  topicClass: 'badge-topic-kids',
  difficulty: 'Beginner',
  difficultyClass: 'badge-difficulty-beginner',
  rating: 4.7,
  reviewCount: 678,
  students: 4210,
  lessons: 10,
  duration: '5h 45m',
  price: 'Free',
  thumbnail: "https://images.unsplash.com/photo-1585071863853-3b66d00b4550",
  thumbnailAlt: 'Young child playing a simple video game on laptop in cozy home setting',
  enrolled: false,
  bestseller: false
}];


const topicChips = ['All', 'AI & Machine Learning', 'Data Science', 'Health Informatics', 'Coding for Kids'];

export default function CatalogueGrid() {
  const [search, setSearch] = useState('');
  const [activeTopicChip, setActiveTopicChip] = useState('All');
  const [sort, setSort] = useState('Most Popular');
  const [wishlist, setWishlist] = useState<string[]>([]);
  const [enrolledIds, setEnrolledIds] = useState<string[]>(allCourses.filter((c) => c.enrolled).map((c) => c.id));

  const topicChipClasses: Record<string, string> = {
    'AI & Machine Learning': 'badge-topic-ai',
    'Data Science': 'badge-topic-data',
    'Health Informatics': 'badge-topic-health',
    'Coding for Kids': 'badge-topic-kids'
  };

  const filtered = allCourses.filter((c) => {
    const matchSearch = c.title.toLowerCase().includes(search.toLowerCase()) || c.instructor.toLowerCase().includes(search.toLowerCase());
    const matchTopic = activeTopicChip === 'All' || c.topic === activeTopicChip;
    return matchSearch && matchTopic;
  });

  const sorted = [...filtered].sort((a, b) => {
    if (sort === 'Highest Rated') return b.rating - a.rating;
    if (sort === 'Most Students') return b.students - a.students;
    if (sort === 'Newest') return 0;
    return b.students - a.students;
  });

  const toggleWishlist = (id: string, e: React.MouseEvent) => {
    e.preventDefault();
    setWishlist((prev) => prev.includes(id) ? prev.filter((w) => w !== id) : [...prev, id]);
  };

  const handleEnroll = (id: string, e: React.MouseEvent) => {
    e.preventDefault();
    // Redirect to sign up — courses are locked until account created
    window.location.href = '/sign-up-login-screen';
  };

  return (
    <div className="flex-1 min-w-0">
      {/* Search + Sort bar */}
      <div className="flex flex-col sm:flex-row gap-3 mb-4">
        <div className="relative flex-1">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search courses or instructors..."
            className="input-field pl-9" />
          
        </div>
        <div className="flex items-center gap-2">
          <SlidersHorizontal size={16} className="text-muted-foreground" />
          <select
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            className="input-field py-2.5 w-auto min-w-[160px]">
            
            {['Most Popular', 'Highest Rated', 'Most Students', 'Newest'].map((s) =>
            <option key={`sort-${s}`}>{s}</option>
            )}
          </select>
        </div>
      </div>

      {/* Topic chips */}
      <div className="flex flex-wrap gap-2 mb-5">
        {topicChips.map((chip) =>
        <button
          key={`chip-${chip}`}
          onClick={() => setActiveTopicChip(chip)}
          className={`px-4 py-1.5 rounded-full text-sm font-medium border transition-all duration-150 ${
          activeTopicChip === chip ?
          'bg-primary text-primary-foreground border-primary' :
          'border-border text-muted-foreground hover:border-primary/40 hover:text-foreground'}`
          }>
          
            {chip}
          </button>
        )}
      </div>

      {/* Results count */}
      <p className="text-sm text-muted-foreground mb-4">
        Showing <span className="font-semibold text-foreground">{sorted.length}</span> courses
        {activeTopicChip !== 'All' && <span> in <span className="font-medium text-foreground">{activeTopicChip}</span></span>}
      </p>

      {/* Grid */}
      {sorted.length === 0 ?
      <div className="flex flex-col items-center justify-center py-20 text-center">
          <BookOpen size={40} className="text-muted-foreground mb-3" />
          <h3 className="font-semibold text-foreground mb-1">No courses found</h3>
          <p className="text-sm text-muted-foreground max-w-xs">
            Try adjusting your search or filters. New courses are added every week.
          </p>
          <button onClick={() => {setSearch('');setActiveTopicChip('All');}} className="btn-secondary mt-4">
            Clear filters
          </button>
        </div> :

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 gap-4">
          {sorted.map((course) => {
          const isWishlisted = wishlist.includes(course.id);
          const isEnrolled = enrolledIds.includes(course.id);
          return (
            <Link key={course.id} href="/course-detail" className="block group">
                <div className="card overflow-hidden card-hover h-full flex flex-col">
                  {/* Thumbnail */}
                  <div className="relative h-44 bg-muted overflow-hidden">
                    <img
                    src={course.thumbnail}
                    alt={course.thumbnailAlt}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                  
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground/30 to-transparent" />
                    {course.bestseller &&
                  <span className="absolute top-2 left-2 text-xs font-bold bg-accent text-white px-2 py-0.5 rounded-full">
                        Bestseller
                      </span>
                  }
                    {isEnrolled &&
                  <span className="absolute top-2 right-10 text-xs font-semibold bg-success text-white px-2 py-0.5 rounded-full">
                        Enrolled
                      </span>
                  }
                    <button
                    onClick={(e) => toggleWishlist(course.id, e)}
                    className="absolute top-2 right-2 w-7 h-7 rounded-full bg-card/80 backdrop-blur-sm flex items-center justify-center transition-all hover:bg-card"
                    aria-label={isWishlisted ? 'Remove from wishlist' : 'Add to wishlist'}>
                    
                      <Heart size={13} className={isWishlisted ? 'fill-danger text-danger' : 'text-muted-foreground'} />
                    </button>
                    <span className={`absolute bottom-2 left-2 ${course.topicClass}`}>{course.topic}</span>
                  </div>

                  <div className="p-4 flex flex-col flex-1">
                    <h3 className="font-semibold text-foreground text-sm leading-snug mb-1 line-clamp-2 group-hover:text-primary transition-colors">
                      {course.title}
                    </h3>
                    <p className="text-xs text-muted-foreground mb-3">{course.instructor}</p>

                    {/* Stats row */}
                    <div className="flex flex-wrap items-center gap-3 text-xs text-muted-foreground mb-3">
                      <span className="flex items-center gap-1 text-amber-500 font-semibold">
                        <Star size={11} fill="currentColor" />
                        {course.rating}
                        <span className="text-muted-foreground font-normal">({course.reviewCount.toLocaleString()})</span>
                      </span>
                      <span className="flex items-center gap-1">
                        <Users size={11} />
                        {course.students.toLocaleString()}
                      </span>
                      <span className="flex items-center gap-1">
                        <BookOpen size={11} />
                        {course.lessons} lessons
                      </span>
                      <span className="flex items-center gap-1">
                        <Clock size={11} />
                        {course.duration}
                      </span>
                    </div>

                    <div className="flex items-center gap-2 mb-4">
                      <span className={course.difficultyClass}>{course.difficulty}</span>
                    </div>

                    <div className="mt-auto flex items-center justify-between">
                      <span className="text-base font-bold text-success">{course.price}</span>
                      {isEnrolled ? (
                        <button
                          onClick={(e) => handleEnroll(course.id, e)}
                          className="btn-secondary py-1.5 px-3 text-xs"
                        >
                          Continue
                        </button>
                      ) : (
                        <button
                          onClick={(e) => handleEnroll(course.id, e)}
                          className="btn-primary py-1.5 px-3 text-xs flex items-center gap-1"
                        >
                          <Lock size={11} />
                          Enrol Free
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </Link>);

        })}
        </div>
      }
    </div>);

}